<template>
  <div class="div">
    <div class="headDom">
      <el-form :model="EditJson" ref="form" label-width="160px" inline>
        <el-form-item
          label="纸张宽度(厘米cm)"
          prop="width"
          :rules="[
            { required: true, message: '宽度不能为空', trigger: 'blur' },
          ]"
        >
          <el-input
            v-model="EditJson.width"
            placeholder="请输入宽度"
            type="number"
            :disabled="!isEdit"
            @input="handleInput($event, 'width')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="纸张高度(厘米cm)"
          prop="height"
          :rules="[
            { required: true, message: '高度不能为空', trigger: 'blur' },
          ]"
        >
          <el-input
            :disabled="!isEdit"
            v-model="EditJson.height"
            placeholder="请输入高度"
            type="number"
            @input="handleInput($event, 'height')"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="EditData" v-if="!isEdit"
          >修改宽高</el-button
        >
        <!-- <el-button @click="closeData" type="" v-if="isEdit">取消</el-button> -->
        <el-button @click="saveData" type="primary" v-if="isEdit"
          >保存宽高</el-button
        >
        <el-form-item label="选择模板">
          <el-select
            v-model="TemplateId"
            placeholder="请选择"
            @change="changeTemplate"
          >
            <el-option
              v-for="item in TemplateList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button @click="Empty" type="danger">清空</el-button>
        <el-button @click="saveTemplate(0)" type="primary">保存模板</el-button>
      </el-form>
    </div>
    <div class="contentDom">
      <el-row>
        <el-col :span="4">
          <el-card class="Dombor">
            <div style="position: relative; padding: 15px">
              <div
                style="
                  position: sticky;
                  top: 0px;
                  left: 0px;
                  z-index: 999;
                  height: 30px;
                  display: flex;
                  align-items: center;
                  background-color: #fff;
                "
              >
                <el-input
                  placeholder="输入关键字进行过滤"
                  v-model="filterText"
                  @input="leftDataSearch"
                >
                </el-input>
              </div>
              <div style="margin-top: 10px">
                <el-button
                  v-for="item in leftData"
                  :key="item.FiledKey + item.FiledName"
                  style="width: 100%; margin: 5px 0"
                  @click="addItem(item)"
                  :class="`${
                    item.FiledKey === ItemInfo.FiledKey ? 'ButtonActive' : ''
                  }`"
                >
                  <span style="color: red" v-if="item.IsEnable"
                    >* {{ item.FieldName }}</span
                  >
                  <span v-else>{{ item.FieldName }}</span>
                </el-button>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="16" style="overflow: auto; padding: 10px">
          <div
            class="Dom"
            :style="`width:${dataJson.width}cm;height:${dataJson.height}cm;position: relative;`"
            body-style="height:100%;"
            @click.self="divcalck"
          >
            <!-- isActive: true, //激活状态
        isDraggable: true, //允许拖拽
        isResizable: true, //允许调整大小
        aspectRatio: false, //是否保持比例
        w: 200,
        h: 40,
        minw: 10,
        minh: 10,
        x: 0,
        y: 0,
        parentW: 0, //父级宽度
        parentH: 0, //父级高度

        parentLimitation: true, //设置为true，则限制操作组件不能超出父级元素
        preventActiveBehavior: false, //单击组件外区域来禁止组件行为 -->
            <VueDragResize
              v-for="(item, index) in printlist"
              :gridX="2"
              :gridY="2"
              :key="item.FiledKey"
              :isActive="item.isActive"
              :preventActiveBehavior="false"
              :isDraggable="item.isDraggable"
              :isResizable="item.isResizable"
              :aspectRatio="item.aspectRatio"
              parentLimitation
              :parentW="getpx(dataJson.width, 'w', 'px')"
              :parentH="getpx(dataJson.height, 'h', 'px')"
              :w="item.w"
              :h="item.h"
              :x="item.x"
              :y="item.y"
              :minh="28"
              :minw="50"
              @clicked="clicked($event, item)"
              @activated="activated($event, item)"
              @resizestop="resizestop($event, item)"
              @dragstop="dragstop($event, item)"
            >
              <div
                style="width: 100%; height: 100%; display: flex"
                v-if="item.FiledKey != 'Id'"
              >
                <div
                  :style="`font-size:${item.title_fontSize}px;font-weight:${item.title_bold};line-height:${item.title_lineHeight}px;text-align:${item.title_align};font-family:${item.title_family};;`"
                >
                  {{ item.FieldName }}：
                </div>

                <div
                  :style="`${
                    item.isline ? 'border-bottom: 1px solid #000;' : ''
                  }flex: 1;font-size:${item.fontSize}px;font-weight:${
                    item.bold
                  };line-height:${item.lineHeight}px;text-align:${
                    item.align
                  };font-family:${item.family};`"
                >
                  {{ item.Value }}
                </div>
              </div>
              <vue-qr
                :size="item.w"
                :text="item.Value"
                :margin="0"
                v-else
              ></vue-qr>
            </VueDragResize>
          </div>
        </el-col>
        <el-col :span="4">
          <el-card class="Dombor">
            <div v-if="ItemInfo.Id" style="padding: 20px">
              <!-- <div style="text-align: center; font-weight: bold; font-size: 16px">
                {{ ItemInfo.FieldName }}
              </div> -->

              <el-form
                :model="ItemInfo"
                size="mini"
                label-position="top"
                label-width="90px"
                style="margin-top: 20px"
                v-if="ItemInfo.FieldName"
              >
                <el-row :gutter="10">
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="标题">
                      <el-input
                        v-model="ItemInfo.FieldName"
                        placeholder="标题"
                        type="textarea"
                        :rows="2"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="内容">
                      <el-input
                        v-model="ItemInfo.Value"
                        placeholder="测试内容"
                        type="textarea"
                        :rows="2"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="显示内容横线">
                      <el-select v-model="ItemInfo.isline" placeholder="请选择">
                        <el-option
                          v-for="item in configuration.islineList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="内容对齐">
                      <el-select v-model="ItemInfo.align" placeholder="请选择">
                        <el-option
                          v-for="item in configuration.alignList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="标题字体">
                      <el-select
                        v-model="ItemInfo.title_family"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in configuration.familyList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="内容字体">
                      <el-select v-model="ItemInfo.family" placeholder="请选择">
                        <el-option
                          v-for="item in configuration.familyList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="标题加粗">
                      <el-select
                        v-model="ItemInfo.title_bold"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in configuration.boldList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="内容加粗">
                      <el-select v-model="ItemInfo.bold" placeholder="请选择">
                        <el-option
                          v-for="item in configuration.boldList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="标题行高">
                      <el-select
                        v-model="ItemInfo.title_lineHeight"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in configuration.lineHeightList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="内容行高">
                      <el-select
                        v-model="ItemInfo.lineHeight"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in configuration.lineHeightList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="标题字体大小">
                      <el-select
                        v-model="ItemInfo.title_fontSize"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in configuration.fontSizeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="ItemInfo.FiledKey != 'Id'">
                    <el-form-item label="内容字体大小">
                      <el-select
                        v-model="ItemInfo.fontSize"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in configuration.fontSizeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="x">
                      <el-input-number
                        v-model="ItemInfo.x"
                        :min="0"
                        label="描述文字"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="y">
                      <el-input-number
                        v-model="ItemInfo.y"
                        :min="0"
                        label="描述文字"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-button
                      style="width: 100%"
                      size="mini"
                      type="danger"
                      @click="itemDetele"
                      >删除</el-button
                    >
                  </el-col>
                </el-row>
              </el-form>
              <el-divider></el-divider>
              <div></div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
    >
      <el-form
        :model="saveInfo"
        size="mini"
        label-position="right"
        label-width="160px"
        v-loading="loading"
      >
        <el-form-item label="是否覆盖当前模板">
          <el-radio-group v-model="radio">
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模板名称">
          <el-input v-model="saveInfo.Name" placeholder="模板名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" v-loading="loading"
          >取 消</el-button
        >
        <el-button type="primary" @click="saveTemplate(1)" v-loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VueDragResize from 'vue-drag-resize'
import uuid from 'node-uuid'
import configuration from './configuration'
import vueQr from 'vue-qr'
function jsgetDPI() {
  var arrDPI = new Array()

  if (window.screen.deviceXDPI != undefined) {
    arrDPI[0] = window.screen.deviceXDPI
    arrDPI[1] = window.screen.deviceYDPI
  } else {
    var tmpNode = document.createElement('DIV')
    tmpNode.style.cssText =
      'width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden'
    document.body.appendChild(tmpNode)
    arrDPI[0] = parseInt(tmpNode.offsetWidth)
    arrDPI[1] = parseInt(tmpNode.offsetHeight)
    tmpNode.parentNode.removeChild(tmpNode)
  }
  return arrDPI
}
export default {
  data() {
    return {
      loading: false,
      configuration,
      dataJson: {
        width: '',
        height: '',
      },

      EditJson: {
        width: '',
        height: '',
      },
      isEdit: false,
      ItemInfo: {},
      filterText: '',
      leftData: [],
      leftDataCopy: [],
      printlist: [],
      dialogVisible: false,
      radio: 0,
      saveInfo: {
        Name: '',
        DataJson: {},
      },
      TemplateId: '',
      TemplateName: '',
      TemplateList: [],
    }
  },
  props: {},
  components: { VueDragResize, vueQr },
  methods: {
    Empty() {
      this.$confirm('确认清空当前模板吗？', '提示', {}).then(() => {
        this.printlist = []
      })
    },
    changeTemplate(id) {
      console.log(id)
      let data = this.TemplateList.find((item) => {
        return item.Id == id
      })
      let obj = JSON.parse(data.DataJson)
      this.dataJson.width = obj.width
      this.dataJson.height = obj.height
      this.EditJson.width = obj.width
      this.EditJson.height = obj.height
      this.printlist = obj.printlist
      this.TemplateName = data.Name
    },
    getTemplateList() {
      this.$http
        .post('/Base_DeviceTreeManage/Device_AssetCardTemplate/GetDataList', {})
        .then((res) => {
          if (res.Success) {
            this.TemplateList = res.Data
          }
        })
    },
    close() {
      this.dialogVisible = false
    },
    saveTemplate(num) {
      if (!num) {
        this.dialogVisible = true
        this.saveInfo.Name = this.TemplateName
        return
      }
      if (this.saveInfo.Name == '') {
        this.$notify.error('模板名称不能为空')
        return
      }

      let obj = {
        ...this.dataJson,
        printlist: this.printlist,
      }
      this.$set(this.saveInfo, 'DataJson', JSON.stringify(obj))
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_AssetCardTemplate/SaveData', {
          ...this.saveInfo,
          Id: this.radio == 1 ? this.TemplateId : '',
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.$notify.success('保存成功')
            this.getTemplateList()
            this.dialogVisible = false
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    divcalck() {
      setTimeout(() => {
        this.printlist.forEach((item) => {
          this.$set(item, 'isActive', false)
        })
      }, 10)
    },
    getLeftData() {
      this.$http
        .post(
          '/Base_DeviceTreeManage/Device_AssetCardTemplate/GetDeviceItemFields'
        )
        .then((res) => {
          if (res.Success) {
            this.leftData = res.Data
            this.leftDataCopy = [...res.Data]
          }
        })
    },
    //缩放结束事件
    resizestop(obj, item) {
      console.log(obj)
      this.$set(item, 'w', obj.width)
      this.$set(item, 'h', obj.height)
      this.$set(item, 'x', obj.left)
      this.$set(item, 'y', obj.top)
      this.ItemInfo = item
    },
    activated() {
      console.log(222)
    },
    clicked(obj, item) {
      console.log(111)
      console.log(obj)
      console.log(item)
      this.printlist.forEach((val) => {
        this.$set(val, 'isActive', false)
      })
      this.$set(item, 'isActive', true)
      this.ItemInfo = item
    },
    dragstop(obj, item) {
      console.log(obj)
      this.$set(item, 'w', obj.width)
      this.$set(item, 'h', obj.height)
      this.$set(item, 'x', obj.left)
      this.$set(item, 'y', obj.top)
      this.ItemInfo = item
    },
    getpx(num, wh, str) {
      var dpi = jsgetDPI()
      if (str == 'px') {
        if (wh == 'w') {
          return (num / 2.54) * dpi[0]
        }
        if (wh == 'h') {
          return (num / 2.54) * dpi[1]
        }
      }
      if (str == 'cm') {
        if (wh == 'w') {
          return (num / dpi[0]) * 2.54
        }
        if (wh == 'h') {
          return (num / dpi[1]) * 2.54
        }
      }
      // px转cm：cm = pxValue/dpi*2.54
      //           px = cm/2.54*dpi
    },
    closeData() {
      this.EditJson.height = this.dataJson.height
      this.EditJson.width = this.dataJson.width
      this.isEdit = false
    },
    saveData() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.dataJson.height = this.EditJson.height
        this.dataJson.width = this.EditJson.width
        this.isEdit = false
      })
    },
    EditData() {
      this.isEdit = true
    },
    itemDetele(ItemInfo) {
      var index = this.printlist.findIndex((val) => {
        return this.ItemInfo.FiledKey === val.FiledKey
      })
      this.printlist.splice(index, 1)
      this.ItemInfo = {}
    },
    addItem(item) {
      this.printlist.forEach((val) => {
        this.$set(val, 'isActive', false)
      })
      var index = this.printlist.findIndex((val) => {
        return item.FiledKey === val.FiledKey
      })
      if (index !== -1) {
        this.printlist[index].isActive = true
        this.ItemInfo = this.printlist[index]
        return
      }
      if (item.FiledKey == 'Id') {
        this.$set(this.printlist, this.printlist.length, {
          ...item,
          Value: '',
          Id: uuid.v4(),
          isActive: false, //激活状态
          isDraggable: true, //允许拖拽
          isResizable: true, //允许调整大小
          aspectRatio: true, //允许调整比例
          w: 100,
          h: 100,
          x: 0,
          y: 0,
        })
        return
      }
      this.$set(this.printlist, this.printlist.length, {
        ...item,
        Value: '',
        Id: uuid.v4(),
        isActive: false, //激活状态
        isDraggable: true, //允许拖拽
        isResizable: true, //允许调整大小
        aspectRatio: false, //允许调整比例
        w: 200,
        h: 28,
        x: 0,
        y: 0,
        family: '黑体',
        title_family: '黑体',
        align: 'left',
        title_align: 'left',
        bold: 'initial',
        title_bold: 'initial',
        lineHeight: '26',
        title_lineHeight: '26',
        isline: true,
        fontSize: '12',
        title_fontSize: '12',
      })
      // this.printlist.push({
      //   ...item,
      //   Value: "",
      //   Id: uuid.v4(),
      //   isActive: false, //激活状态
      //   isDraggable: true, //允许拖拽
      //   isResizable: true, //允许调整大小
      //   w: 200,
      //   h: 40,
      //   x: 0,
      //   y: 0,

      //   // parentLimitation: true, //设置为true，则限制操作组件不能超出父级元素
      //   // preventActiveBehavior: false, //单击组件外区域来禁止组件行为
      // });
    },
    leftDataSearch(a) {
      this.leftData = this.leftDataCopy.filter((item) => {
        return item.FieldName.indexOf(a) != -1
      })
    },
    handleInput(value, field) {
      console.log(value)
      if (value == '') {
        return
      }
      if (parseFloat(value) < 1) {
        this.$notify.error('最小单位为1cm')
        this.EditJson[field] = 1
      } else {
        this.EditJson[field] = value
      }
    },
    submitForm() {},
    resetForm() {},
  },
  mounted() {},
  created() {
    this.getLeftData()
    this.getTemplateList()
    this.dataJson.width = 10
    this.dataJson.height = 10
    this.EditJson.width = 10
    this.EditJson.height = 10
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.div {
  min-width: 1000px;
  overflow: auto;
}
.headDom {
  height: 60px;
}
.contentDom {
  height: calc(100% - 60px);
  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      box-sizing: border-box;
    }
  }
}
.Dombor {
  height: 100%;
  border: 1px solid #e8e8e8;
  overflow-y: auto;
}
.Dom {
  border: 1px solid #e8e8e8;
  margin: 0 auto;
}
::v-deep .el-card .el-card__body {
  padding: 0;
}
</style>
